//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    me(  cancelToken?: CancelToken | undefined): Promise<GetCurrentUserResponse> {
        let url_ = this.baseUrl + "/api/v1/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<GetCurrentUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentUserResponse.fromJS(resultData200);
            return Promise.resolve<GetCurrentUserResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    reports(relativeUrl: string , cancelToken?: CancelToken | undefined): Promise<GetReportResponse> {
        let url_ = this.baseUrl + "/api/v1/reports?";
        if (relativeUrl === undefined || relativeUrl === null)
            throw new Error("The parameter 'relativeUrl' must be defined and cannot be null.");
        else
            url_ += "relativeUrl=" + encodeURIComponent("" + relativeUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReports(_response);
        });
    }

    protected processReports(response: AxiosResponse): Promise<GetReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReportResponse.fromJS(resultData200);
            return Promise.resolve<GetReportResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportResponse>(null as any);
    }

    /**
     * @return Success
     */
    auth(  cancelToken?: CancelToken | undefined): Promise<GetReportAuthResponse> {
        let url_ = this.baseUrl + "/api/v1/reports/auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth(_response);
        });
    }

    protected processAuth(response: AxiosResponse): Promise<GetReportAuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReportAuthResponse.fromJS(resultData200);
            return Promise.resolve<GetReportAuthResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportAuthResponse>(null as any);
    }

    /**
     * @return Success
     */
    refreshPermissions(  cancelToken?: CancelToken | undefined): Promise<PowerBiRefreshPermissionsResponse> {
        let url_ = this.baseUrl + "/api/v1/reports/refreshPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshPermissions(_response);
        });
    }

    protected processRefreshPermissions(response: AxiosResponse): Promise<PowerBiRefreshPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PowerBiRefreshPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<PowerBiRefreshPermissionsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = PowerBiRefreshPermissionsResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = PowerBiRefreshPermissionsResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PowerBiRefreshPermissionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    mappingsAll(  cancelToken?: CancelToken | undefined): Promise<GetMappingsResponse[]> {
        let url_ = this.baseUrl + "/api/v1/mappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMappingsAll(_response);
        });
    }

    protected processMappingsAll(response: AxiosResponse): Promise<GetMappingsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetMappingsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetMappingsResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMappingsResponse[]>(null as any);
    }

    /**
     * @return No Content
     */
    mappingsPOST(body: CreateMappingRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/mappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMappingsPOST(_response);
        });
    }

    protected processMappingsPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 409) {
            const _responseText = response.data;
            return throwException("Conflict", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    mappingsDELETE(relativeUrl: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/mappings?";
        if (relativeUrl === undefined || relativeUrl === null)
            throw new Error("The parameter 'relativeUrl' must be defined and cannot be null.");
        else
            url_ += "relativeUrl=" + encodeURIComponent("" + relativeUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMappingsDELETE(_response);
        });
    }

    protected processMappingsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CreateMappingRequest implements ICreateMappingRequest {
    reportId?: string | undefined;
    relativeUrl?: string | undefined;

    constructor(data?: ICreateMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.relativeUrl = _data["relativeUrl"];
        }
    }

    static fromJS(data: any): CreateMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["relativeUrl"] = this.relativeUrl;
        return data;
    }
}

export interface ICreateMappingRequest {
    reportId?: string | undefined;
    relativeUrl?: string | undefined;
}

export class GetCurrentUserResponse implements IGetCurrentUserResponse {
    displayName?: string | undefined;
    principalName?: string | undefined;
    photo?: string | undefined;
    permissions?: GetCurrentUserResponsePermissions;

    constructor(data?: IGetCurrentUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.principalName = _data["principalName"];
            this.photo = _data["photo"];
            this.permissions = _data["permissions"] ? GetCurrentUserResponsePermissions.fromJS(_data["permissions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["principalName"] = this.principalName;
        data["photo"] = this.photo;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentUserResponse {
    displayName?: string | undefined;
    principalName?: string | undefined;
    photo?: string | undefined;
    permissions?: GetCurrentUserResponsePermissions;
}

export class GetCurrentUserResponsePermissions implements IGetCurrentUserResponsePermissions {
    canManageReportUrlMappings?: boolean;
    canGenerateLogoutLinks?: boolean;

    constructor(data?: IGetCurrentUserResponsePermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canManageReportUrlMappings = _data["canManageReportUrlMappings"];
            this.canGenerateLogoutLinks = _data["canGenerateLogoutLinks"];
        }
    }

    static fromJS(data: any): GetCurrentUserResponsePermissions {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentUserResponsePermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canManageReportUrlMappings"] = this.canManageReportUrlMappings;
        data["canGenerateLogoutLinks"] = this.canGenerateLogoutLinks;
        return data;
    }
}

export interface IGetCurrentUserResponsePermissions {
    canManageReportUrlMappings?: boolean;
    canGenerateLogoutLinks?: boolean;
}

export class GetMappingsResponse implements IGetMappingsResponse {
    reportId?: string;
    relativeUrl?: string | undefined;

    constructor(data?: IGetMappingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.relativeUrl = _data["relativeUrl"];
        }
    }

    static fromJS(data: any): GetMappingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMappingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["relativeUrl"] = this.relativeUrl;
        return data;
    }
}

export interface IGetMappingsResponse {
    reportId?: string;
    relativeUrl?: string | undefined;
}

export class GetReportAuthResponse implements IGetReportAuthResponse {
    accessToken?: string | undefined;
    expiration?: Date;

    constructor(data?: IGetReportAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReportAuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportAuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetReportAuthResponse {
    accessToken?: string | undefined;
    expiration?: Date;
}

export class GetReportResponse implements IGetReportResponse {
    id?: string | undefined;
    name?: string | undefined;
    embedUrl?: string | undefined;

    constructor(data?: IGetReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.embedUrl = _data["embedUrl"];
        }
    }

    static fromJS(data: any): GetReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["embedUrl"] = this.embedUrl;
        return data;
    }
}

export interface IGetReportResponse {
    id?: string | undefined;
    name?: string | undefined;
    embedUrl?: string | undefined;
}

export class PowerBiRefreshPermissionsResponse implements IPowerBiRefreshPermissionsResponse {
    isRefreshRequestedSuccessfully?: boolean;
    lastRefresh?: Date | undefined;

    constructor(data?: IPowerBiRefreshPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRefreshRequestedSuccessfully = _data["isRefreshRequestedSuccessfully"];
            this.lastRefresh = _data["lastRefresh"] ? new Date(_data["lastRefresh"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PowerBiRefreshPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBiRefreshPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRefreshRequestedSuccessfully"] = this.isRefreshRequestedSuccessfully;
        data["lastRefresh"] = this.lastRefresh ? this.lastRefresh.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPowerBiRefreshPermissionsResponse {
    isRefreshRequestedSuccessfully?: boolean;
    lastRefresh?: Date | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}